export const globalInventoryRoot = '/global-inventory'

export const globalInventoryRoute = {
  matrix: '/matrix',
  vendor: '/vendor',
}
